
export default function EducationSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Formación Académica y Certificaciones
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Respaldo académico de las mejores instituciones médicas de México 
            y certificaciones internacionales en cirugía Urológica.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <img 
              src="https://scontent.cdninstagram.com/v/t51.82787-15/576552101_17862188094533668_4694045970633758697_n.jpg?stp=dst-jpg_e35_tt6&_nc_cat=103&ig_cache_key=Mzc2NDMzMTU0Mjg5NTEyMzE0Ng%3D%3D.3-ccb7-5&ccb=7-5&_nc_sid=58cdad&efg=eyJ2ZW5jb2RlX3RhZyI6InhwaWRzLjEwODB4MTM1MC5zZHIuQzMifQ%3D%3D&_nc_ohc=RmdW33BvOCQQ7kNvwF4nFfM&_nc_oc=AdmJPXuYm8TiQ5FL_iam7lYaWPMQbAG06Ezf2mPscOlDvx82h1mBYpZKcN_Yw8wcC5o&_nc_ad=z-m&_nc_cid=0&_nc_zt=23&_nc_ht=scontent.cdninstagram.com&_nc_gid=nw7tx79EXAL67EO41hnejQ&oh=00_Afmk3Htl3yM0nWQCVh9LzHHQA93Dm5MmhMHk2gOy-t00kA&oe=693C4A29"
              alt="Formación Médica Académica"
              className="w-full h-80 object-cover object-top rounded-2xl shadow-2xl"
            />
          </div>
          
          <div className="space-y-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-center mb-4">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-graduation-cap-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">Médico Cirujano</h3>
                  <p className="text-blue-600 font-semibold">Universidad Autonoma de Guadalajara (UAG)</p>
                </div>
              </div>
              <p className="text-gray-600">
                Formación médica integral con especialización en ciencias médicas 
                y fundamentos quirúrgicos en una de las universidades más prestigiosas de México.
              </p>
            </div>
            
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-center mb-4">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-hospital-line text-2xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">Especialidad en Urología</h3>
                  <p className="text-green-600 font-semibold">Universidad de Guadalajara (UdeG)</p>
                </div>
              </div>
              <p className="text-gray-600">
                Especialización completa en urología con entrenamiento en las técnicas 
                más avanzadas de cirugía urológica y manejo integral del paciente urológico.
              </p>
            </div>
            
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-center mb-4">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-award-line text-2xl text-purple-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">Alta Especialidad</h3>
                  <p className="text-purple-600 font-semibold">Centro Qurúrgico Toscano (Italia)</p>
                </div>
              </div>
              <p className="text-gray-600">
                Especialización en cirugía de recontructiva de uretra.
              </p>
            </div>
          </div>
        </div>
        
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-12">
            Miembro de consejos
          </h3>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-robot-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Consejo Nacional </h4>
              <p className="text-sm text-gray-600">Mexicano de Urología</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-green-600"></i>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Consejo Mexicano</h4>
              <p className="text-sm text-gray-600">de Urología</p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-global-line text-2xl text-purple-600"></i>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Sociedad Internacional</h4>
              <p className="text-sm text-gray-600">de Urología Recontructiva</p>
            </div>
          </div>
        </div>
        
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">Educación Médica Continua</h3>
          <p className="text-blue-100 mb-6 max-w-3xl mx-auto">
            Participación constante en congresos internacionales, cursos de actualización 
            y entrenamientos en las técnicas más avanzadas de cirugía Urológica y láser.
          </p>
          <div className="flex justify-center items-center space-x-8">
            <div className="text-center">
              <div className="text-3xl font-bold">20+</div>
              <div className="text-blue-200 text-sm">Congresos Médicos</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold">20+</div>
              <div className="text-blue-200 text-sm">Certificaciones</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold">10+</div>
              <div className="text-blue-200 text-sm">Años de Experiencia</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
